module.exports = __webpack_public_path__ + "img/icon10.3b26ca90.svg";